
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

interface ContentUiState {
  showCreateFolderModal: boolean;
  showCreateSnippetModal: boolean;
  showFileUploadModal: boolean;
  showScrapeWebsiteModal: boolean;
  showAddContentDialog: boolean;
}

const initialState: ContentUiState = {
  showCreateFolderModal: false,
  showCreateSnippetModal: false,
  showFileUploadModal: false,
  showScrapeWebsiteModal: false,
  showAddContentDialog: false,
};

const contentUiSlice = createSlice({
  name: 'contentUi',
  initialState,
  reducers: {
    setShowCreateFolderModal: (state, action: PayloadAction<boolean>) => {
      state.showCreateFolderModal = action.payload;
    },
    setShowCreateSnippetModal: (state, action: PayloadAction<boolean>) => {
      state.showCreateSnippetModal = action.payload;
    },
    setShowFileUploadModal: (state, action: PayloadAction<boolean>) => {
      state.showFileUploadModal = action.payload;
    },
    setShowScrapeWebsiteModal: (state, action: PayloadAction<boolean>) => {
      state.showScrapeWebsiteModal = action.payload;
    },
    setShowAddContentDialog: (state, action: PayloadAction<boolean>) => {
      state.showAddContentDialog = action.payload;
    },
    closeAllContentModals: (state) => {
      state.showCreateFolderModal = false;
      state.showCreateSnippetModal = false;
      state.showFileUploadModal = false;
      state.showScrapeWebsiteModal = false;
      state.showAddContentDialog = false;
    }
  },
});

// Export actions
export const {
  setShowCreateFolderModal,
  setShowCreateSnippetModal,
  setShowFileUploadModal,
  setShowScrapeWebsiteModal,
  setShowAddContentDialog,
  closeAllContentModals,
} = contentUiSlice.actions;

// Export selectors
export const selectShowCreateFolderModal = (state: RootState) => state.contentUi.showCreateFolderModal;
export const selectShowCreateSnippetModal = (state: RootState) => state.contentUi.showCreateSnippetModal;
export const selectShowFileUploadModal = (state: RootState) => state.contentUi.showFileUploadModal;
export const selectShowScrapeWebsiteModal = (state: RootState) => state.contentUi.showScrapeWebsiteModal;
export const selectShowAddContentDialog = (state: RootState) => state.contentUi.showAddContentDialog;

export default contentUiSlice.reducer;
